import script from "./currentOrderPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./currentOrderPanel.vue?vue&type=script&setup=true&lang=js"

import "./currentOrderPanel.vue?vue&type=style&index=0&id=5ef6e380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef6e380"]])

export default __exports__